import Swiper from 'swiper/bundle'
import $ from 'jquery'

const swiper = new Swiper('.testimonialSwiper', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
});

const recent_cases = new Swiper('.recent-cases-swiper', {
  slidesPerView: 3,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".recent-cases-next",
    prevEl: ".recent-cases-prev",
  },
  pagination: {
    el: '.recent-cases-pagination',
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    540: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    860: {
      spaceBetween: 20,
      slidesPerView: 3,
    },
    1200: {
      spaceBetween: 50,
      slidesPerView: 3,
    }
  }
});

const individual_lawyer = new Swiper('.individual-lawyer-swiper', {
  slidesPerView: 1,
  spaceBetween: 50,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".recent-cases-next",
    prevEl: ".recent-cases-prev",
  },
});

const reviews = new Swiper('.reviews-swiper', {
  slidesPerView: 1,
  spaceBetween: 50,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: ".reviews-next",
    prevEl: ".reviews-prev",
  },
});

const attorneys = new Swiper('.attorney-swiper', {
  slidesPerView: 4,
  spaceBetween: 50,
  navigation: {
    nextEl: ".attorney-next",
    prevEl: ".attorney-prev",
  },
  pagination: {
    el: '.attorney-pagination',
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    460: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    860: {
      spaceBetween: 20,
      slidesPerView: 3,
    },
    1300: {
      spaceBetween: 50,
      slidesPerView: 4,
    }
  }
});

// Check if the window width is below 601px
if (window.innerWidth < 601) {
  // Create an Intersection Observer to start autoplay when the swiper is in view
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains('attorney-swiper')) {
          attorneys.params.autoplay = {
            delay: 4000,
            disableOnInteraction: false,
          };
          attorneys.autoplay.start();
        } else if (entry.target.classList.contains('recent-cases-swiper')) {
          recent_cases.params.autoplay = {
            delay: 4000,
            disableOnInteraction: false,
          };
          recent_cases.autoplay.start();
        }
        observer.unobserve(entry.target); // Stop observing once autoplay is started
      }
    });
  }, {
    threshold: 0.5 // Adjust this value as needed
  });

  // Observe the swiper elements
  const swiperElements = document.querySelectorAll('.attorney-swiper, .recent-cases-swiper');
  swiperElements.forEach(swiperElement => {
    if (swiperElement) {
      observer.observe(swiperElement);
    } else {
      console.error('Swiper element not found');
    }
  });
}